import '../assets/styles/Header.css';


export default function Header(){
    return(
<header className='header'>
    
</header>
    );
}